import React from 'react';
import { Avatar, Badge } from '@mui/material';
import {
  getNotificationBadgeIcon,
  getNotificationIcon,
} from '@notifications/registry';
import { INotificationAvatar } from './interfaces';

export const NotificationAvatar: React.FC<INotificationAvatar> = ({
  notification,
}): JSX.Element => {
  const Icon = getNotificationIcon(notification.type);
  const BadgeIcon = getNotificationBadgeIcon(notification.type);
  const avatar = (
    <Avatar sx={{ backgroundColor: 'secondary.main' }}>
      <Icon />
    </Avatar>
  );

  if (!BadgeIcon) {
    return avatar;
  }

  return (
    <Badge
      overlap="circular"
      color="light"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        <BadgeIcon
          sx={{
            width: '14px',
            height: '14px',
          }}
        />
      }
    >
      {avatar}
    </Badge>
  );
};
